<script setup>
defineProps({
  node:       { type: Object,  required: true },
  depth:      { type: Number,  default: 0 },
  selectedId: { type: Number,  default: null },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div>
    <button
      class="w-full flex items-center gap-2 py-1.5 pr-3 hover:bg-n-alpha-1 transition-colors text-left"
      :style="{ paddingLeft: `${12 + depth * 16}px` }"
      :class="selectedId === node.id ? 'bg-indigo-50 dark:bg-indigo-900/20' : ''"
      @click="emit('select', node.id)"
    >
      <span v-if="depth > 0" class="i-lucide-corner-down-right size-3 text-n-slate-7 flex-shrink-0" />
      <span
        class="size-2 rounded-full flex-shrink-0"
        :style="node.color ? `background:${node.color}` : ''"
        :class="!node.color ? 'bg-n-slate-6' : ''"
      />
      <span class="flex-1 text-xs truncate" :class="selectedId === node.id ? 'text-indigo-700 font-semibold dark:text-indigo-300' : 'text-n-slate-12'">
        {{ node.name }}
      </span>
      <span v-if="selectedId === node.id" class="i-lucide-check size-3 text-indigo-600 flex-shrink-0" />
    </button>

    <TypeFilterNode
      v-for="child in node.children"
      :key="child.id"
      :node="child"
      :depth="depth + 1"
      :selected-id="selectedId"
      @select="emit('select', $event)"
    />
  </div>
</template>
